import styled from "styled-components";
import { StyledHomePageContainer, StyledHomePageSectionBlock } from "../styledHomePage";
import { motion } from "framer-motion";

export const StyledHomePageBenefitsWrapper = styled(motion.div)`
  padding: 60px;
  margin: 100px auto;
  width: 100%;
  max-width: 1200px;
  background: #C1B2D7;
  box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  @media (max-width: 992px) {
    padding: 60px 50px;
  }

  @media (max-width: 768px) {
    padding: 40px 15px;
    margin: 0;
    background: inherit;
    box-shadow: none;
  }
`;

export const StyledHomePageBenefitsContainer = styled(StyledHomePageContainer)``;

export const StyledHomePageBenefitsBlock = styled(StyledHomePageSectionBlock)`
  position: relative;
  
  @media (max-width: 768px) {
    h5 {
      font-size: 30px;
      color: #333333;
    }
  }

  @media (min-width: 768px) {
    &:after {
      width: 100%;
      max-width: 400px;
      height: 320px;
      content: '';
      position: absolute;
      top: 250px;
      right: -350px;
      border-radius: 50%;
      background: rgba(155, 104, 228, 0.3);
      filter: blur(125px);
    }

    &:before {
      width: 100%;
      max-width: 400px;
      height: 320px;
      content: '';
      position: absolute;
      top: 110px;
      left: -250px;
      border-radius: 50%;
      background: rgba(155, 104, 228, 0.3);
      filter: blur(125px);
    }
  }

  @media (max-width: 576px) {
    padding: 0;
    .benefits-title {
      margin-bottom: 25px;
    }
  }
`;

export const StyledHomePageBenefitsList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  align-items: baseline;
  row-gap: 35px;
  column-gap: 100px;

  @media (max-width: 992px) {
    justify-content: space-between;
    column-gap: 50px;
  }
  
  @media (max-width: 768px) {
    align-items: unset;
    gap: 10px;
  }
  @media (max-width: 576px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StyledBenefitsItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .circle {
    margin: 0 auto;
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all .3s ease;
    border-radius: 50%;
    cursor: pointer;
    &:before {
      width: 100%;
      max-width: 180px;
      height: 114px;
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.4);
      filter: blur(30px);
      z-index: 1;
      @media (max-width: 576px) {
        max-width: 76px;
        height: 76px;
        filter: blur(5px);
      }
    }
    a {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      z-index: 3;
      img {
        margin: auto;
        width: auto;
        height: auto;
        object-position: center;
        object-fit: contain;
        transition: all .3s ease;
      }
    }
  
  }

  &:hover {
    .circle {
      img {
        transform: scale(1.15);
      }
    }
  }

  .block-responsive {
    position: relative;
    z-index: 10;
  }
  
  @media (max-width: 768px) {
    width: auto;
    height: auto;
    display: block;

    background-color: #C1B2D7;
    border-radius: 10px;
    text-align: center;

    .container-responsive {
      padding-top: 100%;
      border-radius: 50%;
      position: relative;
    }

    .block-responsive {
      width: 70%;
      height: 100%;
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      top: 50%;
      left: 50%;
      -ms-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
    }

    .card-title {
      margin-top: 0;
      margin-bottom: 0;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;


      overflow: hidden;
      text-overflow: ellipsis;
      display: -moz-box;
      -moz-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-clamp: 2;
      box-orient: vertical;
      
    }

    .card-description {
      display: none;
    }

    .circle {
      margin-top: 10px;
      width: 100px;
      height: 100px;
      a {
        width: 60px;
        height: 60px;
        img {
          height: 100%;
        }
      }
    }
    
    &:hover {
      box-shadow: 0.439681px 0.439681px 6.59521px rgba(0, 0, 0, 0.15);
    }
  }
  
  @media (max-width: 576px) {
    &:before {
      content: none;
    }
  }
  
  @media (max-width: 420px) {

    .circle {
      margin-top: 10px;
      width: 70px;
      height: 70px;
      a {
        width: 40px;
        height: 40px;
      }
    }
  }
`;